/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".icon-fixed[_ngcontent-%COMP%]{position:absolute;top:5px;z-index:1000}.z-0[_ngcontent-%COMP%]{z-index:0}"];
export { styles as styles };
